// components/superadmin/MarketersLocationStats.jsx
import { useEffect, useState } from "react";
import { MapPin, Users, Building2, TrendingUp } from "lucide-react";

export default function MarketersLocationStats() {
  const [data, setData] = useState({ byState: [], byLGA: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}superadmin/marketers-performance-by-location`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
      .then(r => r.json())
      .then(d => {
        setData(d);
        console.log(d)
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="p-10 text-center text-xl">Loading location stats...</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold text-purple-700 mb-8 text-center">
        Marketers Performance by Location
      </h1>

      {/* State Summary */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-6">By State</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data?.byState?.map(state => (
            <div key={state._id} className="bg-white p-6 rounded-xl shadow-lg border">
              <div className="flex items-center gap-3 mb-4">
                <MapPin className="w-8 h-8 text-purple-600" />
                <h3 className="text-xl font-bold">{state._id || "Unknown State"}</h3>
              </div>
              <div className="space-y-3">
                <p className="flex justify-between">
                  <span className="flex items-center gap-2"><Users className="w-5 h-5 text-blue-600" /> Seekers</span>
                  <span className="font-bold text-xl text-blue-600">{state.totalSeekers}</span>
                </p>
                <p className="flex justify-between">
                  <span className="flex items-center gap-2"><Building2 className="w-5 h-5 text-green-600" /> Employers</span>
                  <span className="font-bold text-xl text-green-600">{state.totalEmployers}</span>
                </p>
                <p className="flex justify-between">
                  <span className="flex items-center gap-2"><TrendingUp className="w-5 h-5 text-purple-600" /> Total</span>
                  <span className="font-bold text-2xl text-purple-700">{state.totalCreated}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LGA Details */}
      <div>
        <h2 className="text-2xl font-bold mb-6">By LGA (Local Government Area)</h2>
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <table className="w-full">
            <thead className="bg-purple-600 text-white">
              <tr>
                <th className="p-4 text-left">State</th>
                <th className="p-4 text-left">LGA</th>
                <th className="p-4 text-center">Seekers</th>
                <th className="p-4 text-center">Employers</th>
                <th className="p-4 text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              {data.byLGA.map((lga, i) => (
                <tr key={i} className="border-b hover:bg-gray-50">
                  <td className="p-4 font-medium">{lga._id.state}</td>
                  <td className="p-4">{lga._id.lga}</td>
                  <td className="p-4 text-center font-bold text-blue-600">{lga.totalSeekers}</td>
                  <td className="p-4 text-center font-bold text-green-600">{lga.totalEmployers}</td>
                  <td className="p-4 text-center font-bold text-purple-700 text-xl">{lga.totalCreated}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}